import apiWorker from '../apiWorker'

const voicemail = {

    find:   (query)     => apiWorker('get',   `/api/v1/call_center/webhooks/calls/voicemail${query}`),
    update: (_id, data) => apiWorker('patch', `/api/v1/call_center/webhooks/calls/voicemail/${_id}`, data),

}

export default voicemail;